import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const StretchHorizontal: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { width: '20', height: '6', x: '2', y: '4', rx: '2' }],
    ['rect', { width: '20', height: '6', x: '2', y: '14', rx: '2' }],
  ],
];

export default StretchHorizontal;
